import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {verificationT} from '@/lib/types/verification.types';

const sliceName = `verification`;

const VERIFICATION_INITIAL: verificationT = {
  accepted_terms: false,
  is_kyc_verified: false,
  user_uid: '',
  date_modified: '',
  date_removed: '',
  created_at: '',
  is_new_user: true,
  id: 0,
  modified_by: null,
  removed_by: null,
};

const verificationSlice = createSlice({
  name: sliceName,
  initialState: {
    ...VERIFICATION_INITIAL,
  },
  reducers: {
    VERIFICATION_UPDATE: (
      state,
      action: PayloadAction<{
        data?: verificationT;
        prop?: string;
        value?: any;
      }>
    ) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? {[action.payload.prop]: action.payload.value} : null),
      });
    },
  },
});

const {VERIFICATION_UPDATE} = verificationSlice.actions;

export {verificationSlice, VERIFICATION_INITIAL, VERIFICATION_UPDATE};
